import { DomPortal, Portal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PDFTooltipService {
  pdfTooltip$ = new BehaviorSubject<Portal<any>>(null);

  showPdf(tooltipElement) {
    this.pdfTooltip$.next(new DomPortal(tooltipElement));
  }

  hidePdf() {
    this.pdfTooltip$.next(null);
  }
}
